import { arrayToObj } from '@op/utils';
import { DBO_V } from '@op/utils/format';

export type ConfigItemType = {
  key: string;
  text: string;
  header?: string;
  align?: 'left' | 'right';
  hasDetail?: boolean;
  hasSort?: boolean;
  width?: number;
  isPercentage?: boolean;
  isText?: boolean;
  format?: (value: any) => any;
  getRingRatioProps?: (cvm: any) => {
    oldTime: string[];
    newTime: string[];
    oldValue: number;
    newValue: number;
  };
};

export type MetricListType =
  | 'exposure'
  | 'posts'
  | 'reviews'
  | 'account_posts_rate'
  | 'ugc_posts_rate'
  | 'account_exposure'
  | 'official_engagement'
  | 'official_engagement_rate'
  | 'official_views';

export type KeyMetricsItemType = {
  key: MetricListType;
  text: string;
  isPercentage?: boolean;
  format?: (value: any) => any;
  sortItem: string; // 下转页面的排序字段
  filterKeys: // 下转页面的额外参数
  (
    | 'exceptPrivateFilter'
    | 'officialAccountsFilter'
    | 'organization'
    | 'exceptKeywordFilter'
  )[];
  downloadText?: string;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const keyMetricsArray: KeyMetricsItemType[] = [
  {
    key: 'exposure',
    text: 'Potential Impressions-1',
    downloadText: 'Potential Impressions',
    format: (value: number) => DBO_V.reviews(value),
    sortItem: 'follower_number',
    filterKeys: ['exceptPrivateFilter'],
  },
  {
    key: 'posts',
    text: 'Posts-1',
    downloadText: 'Posts',
    format: (value: number) => DBO_V.reviews(value),
    sortItem: 'follower_number',
    filterKeys: ['exceptPrivateFilter'],
  },
  {
    key: 'reviews',
    text: 'Number of Creators-1',
    downloadText: 'Number of Creators',
    format: (value: number) => DBO_V.reviews(value),
    sortItem: 'follower_number',
    filterKeys: ['exceptPrivateFilter'],
  },
  {
    key: 'account_posts_rate',
    text: 'Percentage of Official Posts',
    format: (value: number) => DBO_V.percentageFormat(value * 100),
    isPercentage: true,
    sortItem: 'follower_number',
    filterKeys: ['officialAccountsFilter', 'exceptKeywordFilter'],
  },
  {
    key: 'ugc_posts_rate',
    text: 'Percentage of UGC Posts',
    format: (value: number) => DBO_V.percentageFormat(value * 100),
    isPercentage: true,
    sortItem: 'follower_number',
    filterKeys: ['organization', 'exceptPrivateFilter'],
  },
  {
    key: 'account_exposure',
    text: 'Official Potential Impressions-1',
    downloadText: 'Official Potential Impressions',
    format: (value: number) => DBO_V.reviews(value),
    sortItem: 'follower_number',
    filterKeys: ['officialAccountsFilter', 'exceptKeywordFilter'],
  },
  {
    key: 'official_engagement',
    text: 'Official Engagement',
    format: (value: number) => DBO_V.reviews(value),
    sortItem: 'engagement',
    filterKeys: ['officialAccountsFilter', 'exceptKeywordFilter'],
  },
  {
    key: 'official_engagement_rate',
    text: 'Official Engagement Rate',
    format: (value: number) => DBO_V.percentageFormat(value * 100),
    isPercentage: true,
    sortItem: 'engagement',
    filterKeys: ['officialAccountsFilter', 'exceptKeywordFilter'],
  },
  {
    key: 'official_views',
    text: 'Official Account Views',
    format: (value: number) => DBO_V.reviews(value),
    sortItem: 'view',
    filterKeys: ['officialAccountsFilter', 'exceptKeywordFilter'],
  },
];

export const keyMetricObj = arrayToObj(keyMetricsArray, 'key');

// eslint-disable-next-line @typescript-eslint/naming-convention
export const coreKeyMetricsConfig: ConfigItemType[] = [
  {
    key: 'metric',
    text: 'Metrics',
    align: 'left',
    isText: true,
    width: 180,
    format: (value: string) => {
      return keyMetricObj[value]?.text || value;
    },
  },
  {
    key: 'this_week',
    text: 'This Week-1',
    header: 'This Week',
  },
  {
    key: 'last_week',
    text: 'Last Week-1',
    header: 'Last Week',
  },
  {
    key: 'week_on_week',
    text: 'WoW',
    hasSort: true,
    isPercentage: true,
    getRingRatioProps: (cvm: any) => {
      return {
        oldTime: cvm.last_week_time,
        newTime: cvm.newTime,
        oldValue: cvm.last_week,
        newValue: cvm.this_week,
      };
    },
  },
  {
    key: 'avg_five_week',
    text: 'Past 5-week Average',
    width: 170,
  },
  {
    key: 'avg_five_week_on_week',
    text: 'Compared with Average',
    width: 180,
    hasSort: true,
    hasDetail: true,
    isPercentage: true,
    getRingRatioProps: (cvm: any) => {
      return {
        oldTime: cvm.avg_five_week_time,
        newTime: cvm.newTime,
        oldValue: cvm.avg_five_week,
        newValue: cvm.this_week,
      };
    },
  },
];
